/**
 * Cross-browser compatible idle callback that falls back to setTimeout
 * when requestIdleCallback is not available (e.g., Safari)
 */
export const scheduleIdleCallback = (callback: () => void): void => {
    if (typeof requestIdleCallback === 'undefined') {
        setTimeout(callback, 0)
    } else {
        requestIdleCallback(callback)
    }
}

/**
 * Cross-browser compatible animation frame callback that falls back to setTimeout
 * when requestAnimationFrame is not available (older browsers)
 * Returns a cancel function for cleanup
 */
export const scheduleAnimationFrame = (callback: () => void): (() => void) => {
    if (typeof requestAnimationFrame === 'undefined') {
        const id = setTimeout(callback, 16) // ~60fps fallback
        return () => clearTimeout(id)
    } else {
        const id = requestAnimationFrame(callback)
        return () => cancelAnimationFrame(id)
    }
}
